import { AgencyNewsEnum } from '@model/enum/agency-news.enum';
import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AbstractItem } from '@business/base/abstract-item';
import { MatDialog } from '@angular/material/dialog';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { Constants } from '@utils/constants';
import { AuthServer } from '@services/auth-server.service';
import { NotificationsService } from 'angular2-notifications';
import { ModalNewsComponent } from '@business/modal-news/modal-news.component';
import { FormControl } from '@angular/forms';
import { startWith, map, debounceTime } from 'rxjs/operators';
import { AppUtils } from '@utils/app.utils';
import { take } from 'rxjs/operators';
@Component({
  selector: Constants.WINDOW_NAME_NEWS_WKS,
  templateUrl: './news-wks.component.html'
})
export class NewsWksComponent extends AbstractItem implements OnDestroy {

  @Input() data: any;
  title = Constants.TITLE_CARD_NEWS_WKS;
  filterObj = { agencyID: AgencyNewsEnum.INVESTIMMENTOS_NOTICIA, searchText: '' };
  agencyList = [];
  loading = false;
  newsList = [];
  searchStrCtrl = new FormControl();
  searchObs: any;
  intervalSearch: any;
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;

  constructor(
    _dialog: MatDialog,
    _workspaceService: WorkspaceNewService,
    _itemService: AbstractItemService,
    private _authServer: AuthServer,
    private _notificationService: NotificationsService,
    private _configService: ConfigService,
  ) {
    super(_workspaceService, _dialog, _itemService);
    this.workspaceService = _workspaceService;
    this.dialog = _dialog;
    this.agencyList = this._configService.getNewsListAgency();
    this.searchObs = this.searchStrCtrl.valueChanges
      .pipe(startWith(''),
        debounceTime(1000),
        map(strToSearch => {
          this.filterObj.searchText = strToSearch ? strToSearch.trim() : '';
          if (strToSearch) {
            this.resetInterval();
          }
          this.searchNews();
        }));
    this.searchObs.subscribe();
  }

  ngOnDestroy() {
    this.searchObs = null;
    clearInterval(this.intervalSearch);
  }

  resetInterval() {
    this.intervalSearch = this.intervalSearch ? clearInterval(this.intervalSearch) : null;
    this.intervalSearch = setInterval(() => {
      this.searchNews(true);
    }, 60000);
  }

  searchNews(isUpdate?: boolean) {
    this.loading = !isUpdate ? true : false;
    this.newsList = [];
    this._authServer.iNews.getNewsByParameters(this.filterObj.searchText, this.filterObj.agencyID, new Date(), new Date())
      .pipe(take(1))
      .subscribe(data => {
        if (data) {
          if (data.length < 1) {
            this._notificationService.info('', Constants.DATE_MSG004);
          }
          data.forEach(element => {
            if (element.agencyCode === Number(this.filterObj.agencyID)) {
              this.newsList.push(element);
            }
          });
          if (this.filterObj.searchText) {
            this.newsList = this.filterNewsByString(this.filterObj.searchText);
          }
          this.newsList = this.newsList.length > 0 ? this.newsList.slice(0, Constants.QTD_NEWS_WKS) : [];
          AppUtils.orderObjectDesc(this.newsList, 'newsDate');
          this.loading = false;
        }
      }, () => {
        this.loading = false;
      });
  }

  filterNewsByString(value) {
    const list = this.newsList.filter(element => element.title.toLowerCase().includes(value.toLowerCase()));
    if (list && list.length < 1) {
      this._notificationService.info('', Constants.DATE_MSG004);
    }
    return this.newsList = list;
  }

  openNews(news) {
    const modalNews = this.dialog.open(ModalNewsComponent,
      {
        position: { left: '15px', top: '64px' },
        height: 'calc(100% - 83px)',
        width: 'calc(100% - 30px)',
        maxWidth: 'unset',
        panelClass: 'panel-class-modal-news-component',
        data: news ? { new: news, close: false, origin: null } : null
      });
    if (!news) {

      modalNews.afterOpened().subscribe(data => {
        modalNews.componentInstance.textFilter = this.filterObj.searchText;
        modalNews.componentInstance.agencyFilter = this.filterObj.agencyID;
        const initDate = new Date();
        initDate.setDate(initDate.getDate() - 3);
        modalNews.componentInstance.dateStartFilter = initDate;
        modalNews.componentInstance.dateEndFilter = new Date();
        modalNews.componentInstance.getNews();
      });
    }
  }

}
